import SiteButton from '@/components/atoms/SiteButton'

interface IndustryHeroProps {
    headlineLine1: string;
    headlineLine2: string;
    illustrationDesktop: string;
    illustrationMobile: string;
}

// Illustration only — the same asset used by IndustryPickerSection, recropped
// full-bleed here. No stat, no citation, no picker: just the headline and the
// standard site CTA over it. Mobile/desktop treatment (object-top + bottom
// anchor on mobile, aspect-locked + top-left anchor on desktop) mirrors
// IndustryPickerSection, since it's the same source art with the same
// buildings-at-top / clear-sky-top-left composition.
//
// Headline is two separate line elements, not one wrapped block: standard
// leading within each line, and a 0.4em top margin on the second line — the
// gap a 1.4 line-height would give a single block, applied as space between
// two normal-leading lines instead. line-height alone can't produce two
// different gaps within one element.
export function IndustryHero({ headlineLine1, headlineLine2, illustrationDesktop, illustrationMobile }: IndustryHeroProps) {
    return (
        <section className="relative isolate overflow-hidden rounded-site-panel">
            <img
                src={illustrationMobile}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover object-top md:hidden"
            />
            <img
                src={illustrationDesktop}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 hidden h-full w-full object-cover md:block"
            />

            <div className="relative flex min-h-[620px] flex-col justify-end p-8 md:aspect-[1281/528] md:min-h-0 md:justify-start lg:p-16">
                <h1 className="max-w-2xl font-medium text-unimo-slate">
                    <span className="block text-[28px] leading-normal lg:text-6xl">{headlineLine1}</span>
                    <span className="mt-[0.4em] block text-[28px] leading-normal lg:text-6xl">{headlineLine2}</span>
                </h1>
                <SiteButton href="/pricing" className="mt-6 w-fit lg:mt-8">
                    Buy unimo
                </SiteButton>
            </div>
        </section>
    )
}

export default IndustryHero
